import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import type { Ref } from 'vue';
import { Form, Spin, notification } from 'ant-design-vue';
import router from '@/router';
import i18n from '@/i18n';
import { RouteNames } from '@/enums/routes/RouteNames';
import Resource from '@/models/Resource';
import ResourceRepository from '@/repositories/ResourceRepository';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarResourceEdit',
  setup(__props) {

const FormItem = Form.Item;

const id = ref<string | null>(null);
const itemData = ref({} as Resource) as Ref<Resource | null>;
const isLoading = ref(false);

async function getCalendarResourceData() {
    isLoading.value = true;

    try {
        if (!id.value) {
            return;
        }

        await Resource.getById(id.value);
        itemData.value = ResourceRepository.getById(id.value);
        isLoading.value = false;
    } catch (e) {
        isLoading.value = false;
    }
}

async function addCalendarResource() {
    let resp;
    try {
        if (!id.value && itemData.value) {
            resp = await Resource.createNew(itemData.value);
        }
        if (resp) {
            notification.success({
                message: i18n.t('Promjene uspješne!') as string,
                description: '',
            });
            await router.push({
                name: RouteNames.schedulesResources,
                params: { dynamic: 'CalendarResources' },
            });
        }
    } catch (e) {
        notification.error({
            message: i18n.t('Dogodila se greška') as string,
            description: (e as Error).message,
        });
        await router.push({
            name: RouteNames.schedulesResources,
            params: { dynamic: 'CalendarResources' },
        });
    }
}

async function updateCalendarResource() {
    let resp;
    try {
        if (id.value && itemData.value) {
            resp = await Resource.updateExisting(id.value, itemData.value);
            if (resp && resp.status === 200) {
                notification.success({
                    message: i18n.t('Promjene uspješne!') as string,
                    description: '',
                });
                await router.push({
                    name: RouteNames.schedulesResources,
                    params: { dynamic: 'CalendarResources' },
                });
            }
        }
    } catch (e) {
        notification.error({
            message: i18n.t('Dogodila se greška') as string,
            description: (e as Error).message,
        });
        await router.push({
            name: RouteNames.schedulesResources,
            params: { dynamic: 'CalendarResources' },
        });
    }
}

function goBack() {
    router.go(-1);
}

onMounted(() => {
    id.value = router.currentRoute.params.id === 'nov' ? null : router.currentRoute.params.id;
    if (id.value) {
        getCalendarResourceData();
    }
});

return { __sfc: true,FormItem, id, itemData, isLoading, getCalendarResourceData, addCalendarResource, updateCalendarResource, goBack, Spin }
}

})